import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Container } from 'components';
import { useHistoricLog } from 'apollo/filter-tank-level';
import HistoricLogGraph from './graph';
import { Filters } from './filters';

const stateName = 'waterQuality.filterTankLevel.graphicLog';

export function HistoricLog() {
  const [threshold, setThreshold] = useState({});
  const [yValuesMax, setYValuesMax] = useState(0);
  const { data, loading } = useHistoricLog();
  const { dataPoints } = useSelector(({ customers: { data } }) => data);
  const {
    waterQuality: {
      filterTankLevel: {
        graphicLog: { dataPoint },
      },
    },
  } = useSelector(({ state }) => state);

  useEffect(() => {
    if (dataPoint) {
      const data = dataPoints.find((key) => {
        return key._id === dataPoint;
      });
      setThreshold(data.setting.tank_level.threshold);
      setYValuesMax(data.setting.tank_level.yValuesMax);
    }
  }, [dataPoint, dataPoints]);

  return (
    <Container>
      <Filters stateName={stateName} />
      <HistoricLogGraph
        data={data}
        loading={loading}
        threshold={threshold}
        yValuesMax={yValuesMax}
      />
    </Container>
  );
}
